import omitBy from 'lodash/omitBy';

import { ProjectGeoDataByIri } from 'src/constants/projectGeoData';
import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeAttributeFromGeoData =
  (attributeIri: string) => (model: Model) => {
    const geoDataByIri = Object.entries(model.modelData.geoDataByIri).reduce<
      Record<string, ProjectGeoDataByIri>
    >((acc, [classIri, geoData]) => {
      const updatedGeoData = omitBy(
        geoData,
        (value) => value?.isAttribute && value.value === attributeIri
      );

      // Only keep class entry if it has at least one geo property
      if (Object.keys(updatedGeoData).length > 0) {
        acc[classIri] = updatedGeoData;
      }

      return acc;
    }, {});

    setDataProperty<ModelData>(model)(
      model.modelData,
      'geoDataByIri',
      geoDataByIri
    );
  };
